<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <TopBar />
      </q-header>
      <q-page-container>
        <div id="wrapper" class="full-width full-height">
        </div>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import TopBar from '@/shared/top-bar/components/TopBar.vue';
import '@/components/Usuarios/assets/css/css_usuario_vue.css';
import { QLayout, QHeader, QPageContainer } from 'quasar';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';

export default {
  components: {
    TopBar,
    QLayout,
    QHeader,
    QPageContainer
  },
  mixins: [Message, Validation],
  mounted () {
    this.validacion();
  },
  methods: {
    validacion () {
      let mail = this.$route.query.mail;
      let token = this.$route.query.token;

      if (this.checkIfEmpty([mail, token])) {
        this.showError('Email o token no válido.');
        this.$router.push('/login');
      } else {
        let bodyParams = {
          data: {
            mail: mail,
            token: token.replace(/ /g, '+')
          }
        };

        let request = {
          controller: '/AnonymousUser/Validate',
          filter: {},
          body: bodyParams
        };

        this.$store
          .dispatch('PF/postSuit', request)
          .then((response) => {
            this.showMessage('Usuario activado correctamente.');
            this.$router.push('/login');
          })
          .catch((err) => {
            this.showError(err.message);
            this.$router.push('/login');
          });
      }
    }
  }
};
</script>
